export default "__VITE_ASSET__CKpAw55K__"